import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getQueryBody, getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { TabPanel } from '@mui/lab';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import AppDao from '../../../../data/AppDao';
import { useUserDerivedBounds } from '../../../../GoogleMapV4/hooks/useUserDerivedBounds';
import { getBounds } from '../../../../GoogleMapV4/mapfns/translation';
const debug = process.env.REACT_APP_DEBUG && false;
export const GatewayQuery = ({ value }) => {
    const [gateways, setGateways] = useState([]);
    const { userDevice: { userDevicePosition }, } = useUserDerivedBounds({});
    const getGateways = async (bounds) => {
        const locationLatKey = 'location.lat';
        const locationLngKey = 'location.lng';
        const sw = bounds.getSouthWest();
        const ne = bounds.getNorthEast();
        const query = getQueryBody({
            adjacencyType: AdjacentType.SUBJECT,
            contextObject: getZombieInstanceFromPrimaryKey('Gateway:'),
            ExclusiveStartKey: undefined,
            filterGroups: [
                {
                    setOperation: LogicalOperatorType.AND,
                    filters: [
                        { key: locationLatKey, predicate: ComparisonType.LESS_EQUAL, value: ne.lat() },
                        { key: locationLatKey, predicate: ComparisonType.GREATER_EQUAL, value: sw.lat() },
                        { key: locationLngKey, predicate: ComparisonType.LESS_EQUAL, value: ne.lng() },
                        { key: locationLngKey, predicate: ComparisonType.GREATER_EQUAL, value: sw.lng() },
                    ],
                },
            ],
        });
        debug && console.log('Gateway query', query);
        const { err, data } = await AppDao.getMainTableQueryResultsWithReturn(query);
        if (err) {
            console.error(err);
        }
        if (data) {
            setGateways(data.Items);
        }
    };
    useEffect(() => {
        if (userDevicePosition) {
            const bounds = getBounds([new google.maps.LatLng(userDevicePosition)]);
            if (bounds) {
                getGateways(bounds);
            }
        }
    }, []);
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "Query test" }), JSON.stringify(gateways.map((gw) => gw.name))] }, 'batchPut'));
};
